import BaseCardBehavior from './BaseCardBehavior';
import { ICardModifierData } from 'Prototype/Level/Card/ICardModifierData';
import CardStateHelper, { getCardsState } from '../CardStateHelper';
import { CardTask } from '../CardTasks';
import CardStateModifierHelper from '../CardStateModifierHelper';
import { CardModifierType } from 'Prototype/Level/Card/CardModifierType';
import { SCORE_SCISSOR_CARD, SCORE_ROPE_CARD } from 'Constants/Score';
import { PlaySound } from 'System/Audio/AudioHelper';
import { IGameState } from '../../Game/IGameState';
import { ICardsState } from '../ICardState';

export default class ScissorCardBehavior extends BaseCardBehavior {
    public play(state: IGameState): IGameState {
        let cardsState: ICardsState = getCardsState(state);
        const targets: string[] = [];

        // Find all rope modifiers 'in-play' and 'play' them.
        cardsState.inPlay.forEach((cardID: string) => {
            cardsState.cards[cardID].modifiers
                .filter((modifier: ICardModifierData) => modifier.type === CardModifierType.rope)
                .forEach((modifier: ICardModifierData) => {
                    state = CardStateModifierHelper.playModifier(state, modifier, cardID);
                    targets.push(cardID);
                });
        });

        cardsState = getCardsState(state);

        // Discard this card.
        state = CardStateHelper.updateGameState(state, cardsState);
        state = CardStateHelper.setCardDiscarded(state, this.cardID);
        cardsState = getCardsState(state);

        // Add score.
        const scores: number[] = [SCORE_SCISSOR_CARD];

        // If the targets (ropes) are not longer blocking, each one adds 100 points.
        cardsState.inPlay.forEach((cardID: string) => {
            cardsState.cards[cardID].modifiers
                .filter((modifier: ICardModifierData) => modifier.type === CardModifierType.rope)
                .forEach((modifier: ICardModifierData) => {
                    if (
                        CardStateModifierHelper.getModifierBehavior(cardsState, modifier, cardID).isBlocking(
                            cardsState
                        ) === false
                    ) {
                        scores.push(SCORE_ROPE_CARD);
                    }
                });
        });

        cardsState = CardStateHelper.addTurnScore(cardsState, ...scores);

        // Trigger scissors task.
        cardsState = CardStateHelper.setStateTaskData(cardsState, {
            task: CardTask.SCISSOR,
            source: this.cardID,
            cards: targets,
            cardsScore: [...scores],
        });

        // Clear the undo history when a crab card is played.
        cardsState = CardStateHelper.clearUndoHistory(cardsState);
        
        state = CardStateHelper.updateGameState(state, cardsState);
        state = CardStateHelper.updateCards(state);
        state = CardStateModifierHelper.onCardPlayed(state, this.cardID);
        PlaySound('RopeAndScissors_Audio');
        
        return state;
    }
}
